import { put, select } from 'redux-saga/effects';
import { selectedTicketId } from '../../my-tickets/getters';
import { invoiceFields } from '../../invoice/getters';
import {
  generateInvoice
} from '../../../lib/api-helper';
import {
  GENERATE_INVOICE_SUCCESS,
  GENERATE_INVOICE_ERROR
} from '../actions';
import {
  ADD_FLASH_MESSAGE
} from '../../my-tickets/actions';

export function* createInvoice()  {
  try {
    const ticketId =  yield select(selectedTicketId);
    const fields = yield select(invoiceFields);
    const res = yield generateInvoice(fields, ticketId);

    if (res && res.errors) {
      yield put({ type: ADD_FLASH_MESSAGE, payload: { level: 'danger', message: 'createInvoiceError' }});
    }
    else {
      yield put({ type: GENERATE_INVOICE_SUCCESS, payload: res });
      yield put({ type: ADD_FLASH_MESSAGE, payload: { level: 'success', message: 'createInvoiceSuccess' }});
    }
  }
  catch (e) {
    yield put({ type: GENERATE_INVOICE_ERROR, e });
    yield put({ type: ADD_FLASH_MESSAGE, payload: { level: 'danger', message: 'createInvoiceError' }});
  }
}



// WEBPACK FOOTER //
// ./src/modules/invoice/actions/sagas.js